import React, { useState, useEffect, useRef } from "react";
import { jwtDecode } from 'jwt-decode';

import MessageSection from "./Components/MessageSection";
import DashboardNavbar from "../Navbar/navbar-dashboard";
import ModernNavbarPureCSS from "../../components/Navbar/ModernNavBarPureCSS";


const Index = () =>
{
    const [BusinessNotification, setBusinessNotification] = useState(true);
    const [username, setUsername] = useState('');

    useEffect(() => {

    const token = localStorage.getItem('token');

    if (token) {
      const decodeToken = jwtDecode(token);

      console.log("Decoded Token:", decodeToken);
      setUsername(decodeToken.UserName || 'User');

    }
  }, []);

    return (
        <div>
            <ModernNavbarPureCSS UserName={username} prefix={''} TabActiveId={'messages'} />
            
            <MessageSection setNotification={setBusinessNotification} notification={BusinessNotification} />
        </div>
    );
};

export default Index;
